var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66677 1.53333H2.70677C2.10938 1.53333 1.81046 1.53333 1.58229 1.64959C1.38159 1.75186 1.21852 1.91492 1.11626 2.11563C1 2.3438 1 2.64271 1 3.2401V7.29344C1 7.89083 1 8.18937 1.11626 8.41754C1.21852 8.61824 1.38159 8.78159 1.58229 8.88385C1.81024 9 2.1088 9 2.70502 9H6.76165C7.35787 9 7.656 9 7.88394 8.88385C8.08465 8.78159 8.24826 8.61809 8.35052 8.41738C8.46667 8.18943 8.46667 7.8912 8.46667 7.29498V6.33333M9 3.66667V1M9 1H6.33333M9 1L5.26667 4.73333",
    stroke: "#4B4B4B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4e34d935457abeb3ac67d7ecb89ad948.svg";
export { ForwardRef as ReactComponent };